<form [formGroup]="onderhoudsverplichtigenAangever">
    <div *ngIf="pgaOnderhoudsverplichtigenAangever.length > 0">
        <div formArrayName="pgaOnderhoudsverplichtigenAangever">
            <div *ngFor="let item of pgaOnderhoudsverplichtigenAangever.controls; let i = index; "
                 [formGroupName]="i" class="row">
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Betaalde alimentatie' : ''"
                                                  align="right"
                                                  class="col-auto custom-input-175"
                                                  formControlName="periodiekBetaald"
                                                  id="periodiekBetaald"
                                                  prefix="€"

                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Betaalde afkoopsom' : ''"
                                                  [minValue]="1"
                                                  align="right"
                                                  class="col-auto custom-input-175"
                                                  formControlName="betaaldeAfkoopsom"
                                                  id="betaaldeAfkoopsom"
                                                  prefix="€"

                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Pensioenverrekening' : ''"
                                                  [minValue]="1"
                                                  align="right"
                                                  class="col-auto custom-input-175"
                                                  formControlName="verrekeningPensioenrechten"
                                                  id="verrekeningPensioenrechten"
                                                  prefix="€"

                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Verhaalde bijstand' : ''"
                                                  [minValue]="1"
                                                  align="right"
                                                  class="col-auto custom-input-175"
                                                  formControlName="bijstandEx"
                                                  id="bijstandEx"
                                                  prefix="€"

                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Overige verplichtingen' : ''"
                                                  [minValue]="1"
                                                  align="right"
                                                  class="col-auto custom-input-175"
                                                  formControlName="overigeOnderhoudsverplichtingen"
                                                  id="overigeOnderhoudsverplichtingen"
                                                  prefix="€"

                >
                </snelstart-ui-number-form-control>
                <div class="row col-auto">

                    <snelstart-ui-button (click)="this.showDialog(i)"
                                         [class]="i === 0 ? 'me-1 pt-3 custom-input-200' : 'me-1 custom-input-200'"
                                         icon="plus"
                                         type="secondary">Gegevens ex-partner
                    </snelstart-ui-button>
                </div>
                <snelstart-ui-button (click)="verwijderRijOnderhoudsverplichtigenAangever(i)"
                                     [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                     icon="trash"
                                     iconType="light"
                                     id="buttonDeleteKosten"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
            </div>
        </div>
    </div>
</form>

<div *ngIf="pgaOnderhoudsverplichtigenAangever.length === 0">
    <snelstart-ui-button (click)="addRijOnderhoudsverplichtigenAangever()" class="snelstart-ui-button" icon="plus"
                         type="link">Betaalde partneralimentatie
    </snelstart-ui-button>
</div>
<div *ngIf="pgaOnderhoudsverplichtigenAangever.length > 0">
    <snelstart-ui-button (click)="addRijOnderhoudsverplichtigenAangever()" class="snelstart-ui-button" icon="plus"
                         type="link">Partneralimentatie toevoegen
    </snelstart-ui-button>
</div>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="gegevensAlimentatieOntvanger" size="lg"
                                title="Gegevens ex-partner">
    <snelstart-ui-dialog-body>
        <form [formGroup]="onderhoudsverplichtigenAangever">
            <div formArrayName="pgaOnderhoudsverplichtigenAangever">
                <div *ngFor="let item of pgaOnderhoudsverplichtigenAangever.controls; let i = index; "
                     [formGroupName]="i">
                    <div *ngIf="i === this.index">
                        <div class="col-auto" formGroupName="exPartner">
                            <div formGroupName="gegevensAlimentatieGerechtigde">
                                <div class="row col-auto">
                                    <snelstart-ui-text-form-control
                                            (change)="saveForm()"
                                            class="col-auto custom-input-150"
                                            formControlName="voorletters"
                                            id="voorletters"
                                            label="Voorletters"
                                    >
                                    </snelstart-ui-text-form-control>
                                    <snelstart-ui-text-form-control
                                            (change)="saveForm()"
                                            class="col-auto custom-input-125"
                                            formControlName="tussenvoegsels"
                                            id="tussenvoegsels"
                                            label="Tussenv."
                                    >
                                    </snelstart-ui-text-form-control>
                                </div>


                                <snelstart-ui-text-form-control
                                        (change)="saveForm()"
                                        class="custom-input-250"
                                        formControlName="achternaam"
                                        id="Achternaam"
                                        label="Achternaam"
                                >
                                </snelstart-ui-text-form-control>

                                <snelstart-ui-date-form-control
                                        (change)="saveForm()"
                                        class="custom-input-250"
                                        formControlName="geboortedatum"
                                        id="geboortedatum"
                                        label="Geboortedatum"
                                >
                                </snelstart-ui-date-form-control>

                                <snelstart-ui-bsn-form-control (change)="saveForm()"
                                                               class="custom-input-250"
                                                               formControlName="bsn"
                                                               id="bsn"
                                                               label="Burgerservicenummer"
                                >
                                </snelstart-ui-bsn-form-control>
                            </div>


                            @if (!pgaOnderhoudsverplichtigenAangever.at(index).get('exPartner.gegevensAlimentatieGerechtigde.bsn')?.value) {
                                <p>Adresgegevens alleen invullen als er geen BSN ingevuld wordt.</p>

                                <div formGroupName="adresAlimentatieGerechtigde">

                                    <div class="row col-auto">
                                        <snelstart-ui-text-form-control
                                                (change)="saveForm()"
                                                class="col-auto custom-input-100"
                                                formControlName="postcode"
                                                id="postcode"
                                                label="Postcode"
                                        >
                                        </snelstart-ui-text-form-control>
                                        <snelstart-ui-text-form-control
                                                (change)="saveForm()"
                                                class="col-auto custom-input-100"
                                                formControlName="huisNummer"
                                                id="huisNummer"
                                                label="Huisnr."
                                        >
                                        </snelstart-ui-text-form-control>
                                        <snelstart-ui-text-form-control
                                                (change)="saveForm()"
                                                class="col-auto custom-input-75"
                                                formControlName="huisNummerToevoeging"
                                                id="huisNummerToevoeging"
                                                label="Toev."
                                        >
                                        </snelstart-ui-text-form-control>
                                    </div>
                                    <snelstart-ui-select-form-control (change)="saveForm()"
                                                                      [options]="optionsLandcodes"
                                                                      [required]=true
                                                                      class="custom-input-250"
                                                                      formControlName="landCode"
                                                                      label="Land"
                                    >
                                    </snelstart-ui-select-form-control>
                                </div>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex mt-2">
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
        <snelstart-ui-button icon="check" id="save" type="primary">Opslaan</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

